import { createContext } from "react";

import { STEP_GROUP } from "../../components/TutorialMode/types/enums";
import { TutorialInitialState } from "./tutorialReducer";

interface TutorialContextState extends TutorialInitialState {
    setDrawerStatus: (isOpen: boolean) => void;
    setStepIndex: (index: number) => void;
    setTutorialOpen: (
        isOpen: boolean,
        index?: number,
        stepGroup?: STEP_GROUP,
        keepActive?: boolean
    ) => void;
    setInitialRender: (render: boolean) => void;
}

const TutorialContext = createContext({} as TutorialContextState);

export default TutorialContext;
